var _circle, _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F2ECF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fill: "#D8D8D8",
    d: "M3 3h30v30H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 9.567a1.57 1.57 0 011.57-1.569h12.86c.867 0 1.57.703 1.57 1.57v16.474a.843.843 0 01-1.421.613.843.843 0 00-1.158 0l-.421.398c-.561.53-1.439.53-2 0a1.456 1.456 0 00-2 0c-.561.53-1.439.53-2 0a1.456 1.456 0 00-2 0c-.561.53-1.439.53-2 0l-.421-.398a.843.843 0 00-1.158 0 .843.843 0 01-1.421-.613V9.567z",
    fill: "url(#report_svg__a)",
    stroke: "#000",
    strokeWidth: 0.898
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.999 12h4.406z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.999 12h4.406",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.999 15h9.863z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.999 15h9.863",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.999 18.002h9.863z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.999 18.002h9.863",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.999 20.998h8.528z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.999 20.998h8.528",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "report_svg__a",
    x1: 16.614,
    y1: -0.643,
    x2: -0.621,
    y2: 14.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })))));
}
export default SvgReport;